import angular from 'angular';
import lenderLogo from './lenderLogo';
import './style.scss';

export default angular
  .module('components.lenderLogo', [])
  .component('lenderLogo', lenderLogo).name;
